import { classnames } from '@aibees/shared/utils';
import { Avatar, Box, Typography } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { TestimonialCompanyProps as Props } from './types';

export const TestimonialCompany = memo(
  ({ company, logo, className }: Props) => {
    return (
      <Box className={classnames('TestimonialCompany', className)} sx={SX.root}>
        <Avatar src={logo} alt={company} variant="rounded" size={22} />
        <Typography variant="body4" color="grey.700" fontWeight={700} noWrap>
          {company}
        </Typography>
      </Box>
    );
  }
);

TestimonialCompany.displayName = 'TestimonialCompany';
